
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business",
      function () {
        return require("private-next-pages/business/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business"])
      });
    }
  